import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './livesession.scss';
import { t } from '../../services/i18nService';
import liveSessionCallSelector from '../../selectors/livesession/LiveSessionCallSelector';
import ProctorCallContainer from './ProctorCall';

export class LiveSessionCall extends React.PureComponent {
    static propTypes = {
        // resolved
        mirrorWebcamStream: PropTypes.object,
        proctorIds: PropTypes.array.isRequired,
        shouldShowCandidateReconnecting: PropTypes.bool.isRequired,
    };

    setMirrorWebcamRef = (element) => {
        const { mirrorWebcamStream } = this.props;
        this.mirrorWebcam = element;

        if (this.mirrorWebcam) {
            this.mirrorWebcam.srcObject = mirrorWebcamStream;
        }
    };

    render() {
        const {
            proctorIds,
            shouldShowCandidateReconnecting,
        } = this.props;

        const callClass = [styles.streamMirror, styles.callerWrapper, styles.mirrorCallerWrapper];
        callClass.push(shouldShowCandidateReconnecting ? styles.reconnectingContainer : styles.onlineContainer);

        return (
            <div className={styles.liveProctoringWrapper}>
                <div className={`${styles.callerWrapper} ${styles.remoteCallerWrapper}`}>
                    {proctorIds.map((proctorId) => {
                        return <ProctorCallContainer key={proctorId} proctorId={proctorId} />;
                    })}
                </div>

                <div className={callClass.join(' ')}>
                    <div className={styles.cameraContainer}>
                        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
                        <video
                            className={styles.mirrorWebcam}
                            ref={this.setMirrorWebcamRef}
                            autoPlay
                            muted
                        />
                        { shouldShowCandidateReconnecting &&
                            <div className={styles.reconnectingCall}>
                                <i className="fa fa-refresh fa-spin" aria-hidden="true" />
                                {t('liveSession.reconnecting')}
                            </div>
                        }
                    </div>

                    <div className={styles.streamMirrorInfo}>
                        <p className={styles.liveSessionCallStartedTitle}>{t('liveSession.title')}</p>
                        <p>{t('liveSession.description')}</p>
                    </div>
                </div>
            </div>
        );
    }
}

const LiveSessionCallContainer = connect(liveSessionCallSelector.mapStateToProps)(LiveSessionCall);
export default LiveSessionCallContainer;
